import script from "./SportHeroBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./SportHeroBanner.vue?vue&type=script&setup=true&lang=js"

import "./SportHeroBanner.vue?vue&type=style&index=0&id=6636eb7b&lang=scss"

const __exports__ = script;

export default __exports__